var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgErrorCircle = function SvgErrorCircle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M42.267,37.93,32.133,27.8,42.267,17.661a3.073,3.073,0,0,0-4.346-4.346L27.787,23.449,17.652,13.315a2.94,2.94,0,0,0-4.346,0,2.969,2.969,0,0,0,0,4.346L23.44,27.8,13.306,37.93a2.971,2.971,0,0,0,0,4.346,3.053,3.053,0,0,0,4.346,0L27.787,32.142,37.921,42.276a3.088,3.088,0,0,0,4.346,0A3.053,3.053,0,0,0,42.267,37.93Z",
    transform: "translate(15.588 15.58)",
    fill: "#d20790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M43.375,8.76a34.621,34.621,0,0,1,24.481,59.1A34.621,34.621,0,0,1,18.894,18.894,34.386,34.386,0,0,1,43.375,8.76m0-5.385a40,40,0,1,0,40,40,39.994,39.994,0,0,0-40-40Z",
    fill: "#d20790"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-circle.940e7066.svg";
export { ForwardRef as ReactComponent };